import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadHistory } from './actions'
import { forceRender } from '../../../../../../../../components/VirtualizedList/actions'

const mapStateToProps = (state) => ({
    loading: state.getIn(['ui', 'entityStack', 'history', 'loading']),
    loaded: state.getIn(['ui', 'entityStack', 'history', 'loaded']),
    historyCollection: state.getIn(['ui', 'entityStack', 'history', 'entities']),
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            loadHistory,
            forceRender,
        },
        dispatch
    )

export default (HistoryContentComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            historyCollection: IPropTypes.list.isRequired,
            loaded: PropTypes.bool.isRequired,
            loadHistory: PropTypes.func.isRequired,
            loading: PropTypes.bool.isRequired,
        }

        render() {
            return <HistoryContentComponent {...this.props} />
        }
    }

    return HocConnect
}
